import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	groupIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	groupIcon: {
		id: 'jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon',
		defaultMessage: 'Group Icon',
		description: 'The text used on the group icon label',
	},
});
export default messages;
